{
  "account-not-existed-dialog": {
    "buttons": {
      "cancel": "Hủy",
      "sign-up": "Đăng ký"
    },
    "text": {
      "hint": "Nếu bạn là người dùng mới, vui lòng tạo tài khoản của bạn trước!",
      "not-found-account-with-email": "Không có tài khoản được đăng ký với email {{ email }}",
      "not-found-account-with-phone-nr": "Không có tài khoản được đăng ký với số điện thoại {{ phoneNr }}",
      "title": "Tài khoản không tồn tại"
    }
  }
}
